import LocalStore from './LocalStore';

const LocalStorage = new LocalStore()

export default LocalStorage;